import Vue from "vue";

export const catalogues = {
  // 2900 - SasCarteAffaire
  SasCarteAffaire: {
    // 2929 - SasCarteAffaire.UtilisationDeLAdresse
    UtilisationDeLAdresse: {
      DomicileProfessionnel: "kK45TYTNqR1EpL4yq4KTB9IqgUgR1EpL1R1EpL1",
    },
    // 2930 - SasCarteAffaire.InformationsConfidentielles
    InformationsConfidentielles: {
      AdressePostale: "zMV00TvfCMyoXFPDiKu0nAR1EpL1R1EpL1",
      Courriel: "bV3R1EpL3KNtgInMEwjCuwSLQ7wR1EpL1R1EpL1",
      Telephone: "R1EpL3DiyAX0YKo8KmRyaAixhMgR1EpL1R1EpL1",
    },
    // 2951 - SasCarteAffaire.ProfessionPsy
    ProfessionPsy: {
      Jexerce: "EEGAlR1EpL3hO00UxfjR1EpL4a1rRLaQR1EpL1R1EpL1",
      JexercePas: "3gq7j7zrGR1EpL3Ge7975QR1EpL3RU7AR1EpL1R1EpL1",
    },
  },
};

Vue.prototype.$catalogues = catalogues;
